module.exports = __webpack_public_path__ + "media/img/why/client2-4ed0ac457110f7a7b369aa74f439cc5b.png";